import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Star, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Textarea } from "../components/ui/textarea";
import { api, fmtErr } from "../lib/api";

export default function Survey() {
  const { bookingId } = useParams();
  const [ctx, setCtx] = useState(null);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/surveys/${bookingId}`).then((r) => setCtx(r.data)).catch(() => setError("Survey not found"));
  }, [bookingId]);

  const submit = async () => {
    try {
      await api.post("/surveys", { booking_id: bookingId, rating, comment });
      setDone(true);
    } catch (e) {
      toast.error(fmtErr(e));
    }
  };

  if (error) return <div className="max-w-md mx-auto px-6 py-32 text-center text-muted-foreground">{error}</div>;
  if (!ctx) return <div className="min-h-screen bg-background" />;

  return (
    <div data-testid="survey-page" className="max-w-md mx-auto px-6 py-24 min-h-screen">
      {done ? (
        <div className="text-center py-12">
          <CheckCircle2 className="w-12 h-12 text-emerald-500 mx-auto" />
          <h1 className="font-display text-3xl mt-6">Thank you</h1>
          <p className="text-muted-foreground mt-3 text-sm">Your feedback goes directly to the team at {ctx.restaurant_name} — it's private and helps them improve.</p>
        </div>
      ) : (
        <>
          <p className="text-xs tracking-[0.3em] uppercase text-primary mb-2">Private feedback</p>
          <h1 className="font-display text-3xl tracking-tight">How was {ctx.restaurant_name}?</h1>
          <p className="text-muted-foreground mt-2 text-sm">{ctx.date} at {ctx.time} · Only the restaurant team sees this.</p>
          <div className="flex gap-2 mt-8">
            {[1, 2, 3, 4, 5].map((n) => (
              <Star key={n} data-testid={`survey-star-${n}`} onClick={() => setRating(n)}
                className={`w-9 h-9 cursor-pointer transition-colors ${n <= rating ? "text-amber-400 fill-amber-400" : "text-muted-foreground hover:text-amber-300"}`} />
            ))}
          </div>
          <Textarea data-testid="survey-comment" rows={4} placeholder="Anything we should know? (optional)" value={comment}
            onChange={(e) => setComment(e.target.value)} className="mt-6 bg-card border-border/60" />
          <Button data-testid="survey-submit-btn" onClick={submit} disabled={!rating} className="mt-5 w-full rounded-full">
            Send feedback
          </Button>
        </>
      )}
    </div>
  );
}
